// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".empty i{cursor:default!important}.icon-blank{width:18px;height:18px;border:1px solid #000}.icon-blank.icon-selected{border-color:#0077db!important}", ""]);
// Exports
module.exports = exports;
